import { z } from "zod";

export const syncRunStatusSchema = z.enum(["RUNNING", "SUCCEEDED", "FAILED"]);
export const syncTriggerSchema = z.enum(["SCHEDULE", "MANUAL"]);

export const syncRunViewSchema = z.object({
  id: z.string(),
  jobName: z.string(),
  full: z.boolean(),
  trigger: syncTriggerSchema,
  triggeredByName: z.string().nullable(),
  status: syncRunStatusSchema,
  startedAt: z.string(),
  finishedAt: z.string().nullable(),
  summary: z.record(z.string(), z.number()),
  message: z.string(),
});
export type SyncRunView = z.infer<typeof syncRunViewSchema>;

export const syncRunListResponseSchema = z.object({ runs: z.array(syncRunViewSchema) });
export type SyncRunListResponse = z.infer<typeof syncRunListResponseSchema>;
export const syncRunResponseSchema = z.object({ run: syncRunViewSchema });
export type SyncRunResponse = z.infer<typeof syncRunResponseSchema>;

export const syncJobNameSchema = z.enum(["backlog-lead-scan"]);
export type SyncJobName = z.infer<typeof syncJobNameSchema>;

export const startSyncRequestSchema = z.object({ full: z.boolean().default(false) });
export type StartSyncRequest = z.infer<typeof startSyncRequestSchema>;
